import classNames from "classnames";
import { ArrowLink } from "../../../../../common/components/Link";
import { URL_CONTACT_US } from "../../../../../utils/url/staticUrls";
import { useTranslation } from "react-i18next";
import { styled } from "~/common/mui";

interface Props {
  className?: string;
}

const NotFoundContactUsBar = (props: Props) => {
  const { t } = useTranslation();
  const cls = classNames(props.className);

  return (
    <NotFoundContactUsRoot className={cls}>
      <Text>{t("notFoundContactUs.question")}</Text>
      <ArrowLink href={URL_CONTACT_US}>{t("notFoundContactUs.contact")}</ArrowLink>
    </NotFoundContactUsRoot>
  );
};

export default NotFoundContactUsBar;

const NotFoundContactUsRoot = styled("div")(({ theme }) => ({
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.surface.main,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.up("desktop-s")]: {
    padding: theme.spacing(2.5),
    flexDirection: "row",
    "& .scha__link": {
      position: "relative",
      top: 2,
    },
  },
}));

const Text = styled("span")(({ theme }) => ({
  ...theme.typography.bodyMedium,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up("desktop-s")]: {
    marginBottom: 0,
    marginRight: theme.spacing(3.125),
  },
}));
